import(/* webpackMode: "eager", webpackExports: ["DocsNavigation"] */ "/learn-web/features/navigation/containers/DocsNavigation/DocsNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/learn-web/features/navigation/containers/NavigationProvider/NavigationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/learn-web/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
